import request from "@/utils/request";

/**
 * 销售分类管理 API
 */

// ==================== 分类管理 ====================

/**
 * 保存销售分类
 */
export function saveSaleCategory(data) {
  return request({
    url: '/osp/saleCategory/saveBo',
    method: 'post',
    data: data
  })
}

/**
 * 删除销售分类
 */
export function deleteSaleCategory(data) {
  return request({
    url: '/osp/saleCategory/deleteByBo',
    method: 'post',
    data: data
  })
}

/**
 * 修改销售分类
 */
export function updateSaleCategory(data) {
  return request({
    url: '/osp/saleCategory/updateByBo',
    method: 'post',
    data: data
  })
}

/**
 * 分页查询销售分类
 */
export function querySaleCategoryPage(data) {
  return request({
    url: '/osp/saleCategory/queryPageList',
    method: 'post',
    data: data
  })
}

/**
 * 查询销售分类树
 */
export function querySaleCategoryTree(data) {
  return request({
    url: '/osp/saleCategory/queryTree',
    method: 'post',
    data: data
  })
}

/**
 * 跨组织复制分类
 */
export function copySaleCategory(data) {
  return request({
    url: '/osp/saleCategory/copy',
    method: 'post',
    data: data
  })
}

/**
 * 跨组织对比分类
 */
export function compareSaleCategory(data) {
  return request({
    url: '/osp/saleCategory/compare',
    method: 'post',
    data: data
  })
}

/**
 * 跨组织合并分类
 */
export function mergeSaleCategory(data) {
  return request({
    url: '/osp/saleCategory/merge',
    method: 'post',
    data: data
  })
}

/**
 * 查询操作日志
 */
export function querySaleCategoryLogs(data) {
  return request({
    url: '/osp/saleCategory/queryLogs',
    method: 'post',
    data: data
  })
}

// ==================== 物料分类关联 ====================

/**
 * 批量绑定物料到分类
 */
export function bindMaterials(data) {
  return request({
    url: '/osp/materialSaleCategory/bindMaterials',
    method: 'post',
    data: data
  })
}

/**
 * 批量解绑物料
 */
export function unbindMaterials(data) {
  return request({
    url: '/osp/materialSaleCategory/unbindMaterials',
    method: 'post',
    data: data
  })
}

/**
 * 按分类查询物料
 */
export function queryMaterialsByCategory(data) {
  return request({
    url: '/osp/materialSaleCategory/queryByCategory',
    method: 'post',
    data: data
  })
}

/**
 * 按物料查询分类
 */
export function queryCategoriesByMaterial(data) {
  return request({
    url: '/osp/materialSaleCategory/queryByMaterial',
    method: 'post',
    data: data
  })
}
